<template>
  <div>
    <sdPageHeader :title="$t('menu.coupon-codes')"> </sdPageHeader>

    <Main>
      <sdCards>
        <a-row :gutter="16">
          <a-col :span="4">
            <label> {{ $t('pages.coupons.label-domain-name') }} </label>
            <a-select
              :placeholder="$t('common.choose')"
              style="width: 100%"
              v-model:value="filter.domain"
              @change="onChangeHadle"
            >
              <a-select-option :value="null">
                {{ $t('common.choose') }}
              </a-select-option>
              <a-select-option v-for="(item, index) in domainList" :key="index" :value="item.domain">
                {{ item.domain }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="4">
            <label> {{ $t('pages.coupons.label-app') }} </label>
            <a-select
              :placeholder="$t('common.choose')"
              style="width: 100%"
              v-model:value="filter.app_id"
              @change="onChangeHadle"
            >
              <a-select-option :value="null">
                {{ $t('common.choose') }}
              </a-select-option>
              <a-select-option v-for="coupon in appList" :key="coupon.id" :value="coupon.prefix">
                {{ coupon.title }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="4">
            <label> {{ $t('pages.coupons.label-usage') }} </label>
            <a-select
              :placeholder="$t('common.choose')"
              style="width: 100%"
              v-model:value="filter.is_used"
              @change="onChangeHadle"
            >
              <a-select-option :value="null">
                {{ $t('common.choose') }}
              </a-select-option>
              <a-select-option :value="1">
                {{ $t('pages.coupons.table-used') }}
              </a-select-option>
              <a-select-option :value="0">
                {{ $t('pages.coupons.table-unused') }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="4">
            <label> {{ $t('pages.coupons.label-state') }} </label>
            <a-select
              :placeholder="$t('common.choose')"
              style="width: 100%"
              v-model:value="filter.active"
              @change="onChangeHadle"
            >
              <a-select-option :value="null">
                {{ $t('common.choose') }}
              </a-select-option>
              <a-select-option :value="1">
                {{ $t('pages.coupons.table-active') }}
              </a-select-option>
              <a-select-option :value="0">
                {{ $t('pages.coupons.table-passive') }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="2">
            <label> &nbsp;</label>
            <sdButton size="default" :outlined="true" type="success" style="width: 100%" @click="filterTable">
              {{ $t('pages.coupons.filter') }}
            </sdButton>
          </a-col>
          <a-col :span="2">
            <label> &nbsp;</label>
            <sdButton size="default" :outlined="true" type="primary" style="width: 100%" @click="showModal">
              {{ $t('pages.coupons.add-new') }}
            </sdButton>
          </a-col>
          <a-col :span="4">
            <label> &nbsp;</label>
            <SearchBoxVue v-model:text="filter.search" @text-changed="getTableContent()" />
          </a-col>
        </a-row>
        <br />

        <a-modal v-model:visible="isModalVisible" :footer="null">
          <a-form layout="vertical" :model="form" @submit="handleFinish">
            <a-form-item :label="$t('pages.coupons.modal-domain-name')">
              <a-input v-model:value="form.domain" required />
            </a-form-item>
            <a-form-item :label="$t('pages.coupons.modal-app')">
              <a-select :placeholder="$t('common.choose')" v-model:value="form.app_id">
                <a-select-option v-for="(coupon, index) in appList" :key="index" :value="coupon.id">
                  {{ coupon.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :label="$t('pages.coupons.modal-state')">
              <a-select :placeholder="$t('common.choose')" v-model:value="form.active">
                <a-select-option value="1">{{ $t('pages.coupons.table-active') }}</a-select-option>
                <a-select-option value="0">{{ $t('pages.coupons.table-passive') }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-item :label="$t('pages.coupons.modal-discount-type')">
                  <a-select :placeholder="$t('common.choose')" v-model:value="form.discount_type">
                    <a-select-option value="percent">{{ $t('pages.coupons.model-discount-percent') }}</a-select-option>
                    <a-select-option value="amount">{{ $t('pages.coupons.model-discount-amount') }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-Item :label="$t('pages.coupons.modal-discount-amount')">
                  <a-input v-model:value="form.discount_value" required />
                </a-form-Item>
              </a-col>
            </a-row>

            <sdButton size="default" htmlType="submit" type="primary">{{ $t('pages.coupons.modal-save') }} </sdButton>
          </a-form>
        </a-modal>

        <a-row :gutter="25">
          <a-col :xs="24">
            <div v-if="isLoading" class="spin">
              <a-spin />
            </div>
            <div v-else>
              <a-table
                :rowSelection="rowSelection"
                :pagination="{
                  pageSize: this.filter.pageSize,
                  showSizeChanger: true,
                  total: this.filter.total,
                  current: this.filter.current,
                }"
                :dataSource="this.couponList"
                :columns="columns"
                @change="onTableChange"
                size="small"
              >
                <template #active="{ record }">
                  <a-space>
                    <a-tag :color="record.active ? 'green' : 'red'">
                      {{ record.active ? $t('pages.coupons.table-active') : $t('pages.coupons.table-passive') }}
                    </a-tag>
                  </a-space>
                </template>

                <template #is_used="{ record }">
                  <a-space>
                    <a-tag :color="record.is_used ? 'cyan' : 'blue'">
                      {{ record.is_used ? $t('pages.coupons.table-used') : $t('pages.coupons.table-unused') }}
                    </a-tag>
                  </a-space>
                </template>
              </a-table>
            </div>
          </a-col>
        </a-row>
      </sdCards>
    </Main>
  </div>
</template>

<script>
import { Main } from '../styled';
import { ProjectList } from './overview/style';
import { dateToTr } from '@/utility/helper.js';
import SearchBoxVue from '@/components/search/SearchBox.vue';

export default {
  name: 'couponCodes',
  components: {
    Main,
    ProjectList,
    SearchBoxVue,
  },
  data() {
    return {
      isLoading: true,
      rowSelection: null,
      couponList: [],
      appList: [],
      domainList: [],
      isModalVisible: false,
      form: {
        domain: null,
        app_id: null,
        active: '1',
        discount_type: 'percent',
        discount_value: null,
        title: null,
      },
      isFilterNew: false,
      filter: {
        search: '',
        domain: null,
        app_id: null,
        is_used: null,
        active: null,
        current: 1,
        pageSize: 10,
        total: null,
      },
      columns: [
        {
          title: this.$t('pages.coupons.table-app'),
          dataIndex: 'app_prefix',
          key: 'app_prefix',
        },
        {
          title: this.$t('pages.coupons.table-domain-name'),
          dataIndex: 'domain',
          key: 'domain',
        },
        {
          title: this.$t('pages.coupons.table-coupon-code'),
          dataIndex: 'code',
          key: 'code',
        },
        {
          title: this.$t('pages.coupons.table-creator'),
          dataIndex: 'creator',
          key: 'creator',
        },
        {
          title: this.$t('pages.coupons.table-discount'),
          dataIndex: 'discount_value',
          key: 'discount_value',
        },
        {
          title: this.$t('pages.coupons.table-usage'),
          dataIndex: 'is_used',
          key: 'is_used',
          slots: { customRender: 'is_used' },
        },
        {
          title: this.$t('pages.coupons.table-state'),
          dataIndex: 'active',
          key: 'active',
          slots: { customRender: 'active' },
        },
        {
          title: this.$t('pages.coupons.table-create-date'),
          dataIndex: 'created_at',
          key: 'created_at',
          slots: { customRender: 'created_at' },
        },
      ],
    };
  },
  methods: {
    decoder(value) {
      return atob(value);
    },
    onChangeHadle() {
      this.isFilterNew = true;
    },
    onTableChange(e) {
      this.filter.current = this.isFilterNew ? 1 : e.current;
      this.filter.pageSize = e.pageSize;
      this.getTableContent();
      this.isFilterNew = false;
    },
    filterTable() {
      this.filter.current = 1;
      this.getTableContent();
      this.isFilterNew = false;
    },
    showModal() {
      this.isModalVisible = true;
    },
    hideModal() {
      this.isModalVisible = false;
    },
    clearForm() {
      this.form = {
        domain: null,
        app_id: null,
        active: '1',
        discount_type: 'percent',
        discount_value: null,
      };
    },
    handleFinish() {
      if ((this.form.discount_type == 'percent' && this.form.discount_value > 100) || this.form.discount_value < 1) {
        this.$message.error('Geçerli bir indirim değeri giriniz.');
        return;
      }
      if (this.form.discount_type == 'amount' && this.form.discount_value < 1) {
        this.$message.error('Geçerli bir indirim değeri giriniz.');
        return;
      }
      this.$appAxios.post(this.$endpoints.coupon_set, this.form).then(resp => {
        if (resp.data.status === true) {
          this.$message.success(resp.data.message);
          this.clearForm(); //clear form
          this.getTableContent();
          this.hideModal();
        } else {
          this.$message.error(resp.data.message);
          return;
        }
      });
    },
    getApps() {
      this.$appAxios.post(this.$endpoints.coupon_apps_get).then(resp => {
        if (resp.data.status === true) {
          this.appList = resp.data.data;
        }
      });
    },
    getTableContent() {
      this.isLoading = true;
      this.$appAxios.post(this.$endpoints.coupon_get, this.filter).then(resp => {
        if (resp.data.status === true) {
          var $data = resp.data.data;
          var coupons = $data.tableData;
          this.filter.total = $data.total;
          this.couponList = [];
          var _this = this;
          coupons.forEach(function(item, index) {
            _this.couponList.push({
              key: item.id,
              app_prefix: item.title,
              domain: item.domain,
              code: item.code,
              creator: item.creator,
              discount_value: item.discount_type == 'percent' ? `%${item.discount_value}` : `${item.discount_value}₺`,
              is_used: item.is_used,
              active: item.active,
              created_at: dateToTr(item.created_at),
            });
          });
        }
        this.isLoading = false;
      });
    },
    getDomainList() {
      this.$appAxios.post(this.$endpoints.coupon_domain_get).then(resp => {
        if (resp.data.status === true) {
          this.domainList = resp.data.data;
        }
      });
    }
  },
  created() {
    this.getTableContent();
    this.getApps();
    this.getDomainList();
  },
};
</script>

<style>
.ant-select-selector {
  margin-bottom: 0px !important;
}
</style>
